import React from 'react';
import {
    Show,
    Datagrid,
    TextField,
    ReferenceManyField
} from 'react-admin';

const AccountCoinShow = ({ permissions, ...props }) => {

    const handleRowClick = (id, basePath, record) => {
        const currId = window.location.href.split('#')[1].split('/')[2];
        window.location.href = `#/accountcoins/${currId}@${record.symbol}`;
    }

    const onCreateCoin = () => {
        const currId = window.location.href.split('#')[1].split('/')[2];
        window.location.href = `#/accountcoins/create?accountId=${currId}`;
    }

    const MyShowActions = () => {
        if (permissions === 'system_admin' || permissions === 'operator') {
            return (
                <div style={{ padding: '16px', textAlign: 'right' }}>
                    <button 
                        onClick={onCreateCoin}
                        style={{
                            backgroundColor: '#f50057',
                            color: 'white',
                            border: 'none',
                            padding: '8px 16px',
                            borderRadius: '4px',
                            cursor: 'pointer'
                        }}
                    >
                        Create new coin
                    </button>
                </div>
            );
        }
        return null;
    };

    return (
        <Show {...props} actions={<MyShowActions />} title={'coins for account'}>
            <ReferenceManyField reference="accountcoins" addLabel={false}>
                <Datagrid rowClick={handleRowClick}>
                    <TextField source="symbol" key="symbol" />
                    <TextField source="currency" key="currency" />
                </Datagrid>
            </ReferenceManyField>
    
        </Show>
    )
};

export default AccountCoinShow;
